
<template>
    <div class="center examplex">
      <vs-table striped>
        <template #thead>
          <vs-tr>
            <vs-th>
                Alumno
            </vs-th>
            <vs-th>
                Familiares vinculados en SIGeM
            </vs-th>
            <vs-th>
                Vincular
            </vs-th>
          </vs-tr>
        </template>
        <template #tbody>
          <vs-tr
            :key="i"
            v-for="(tr, i) in users"
            :data="tr"
          >
            <vs-td>
                <p class="mb-0"><small>NOMBRE</small></p>
                <p><strong>{{tr.nombre}}</strong></p>
            </vs-td>
            <vs-td>
                <div v-if="tr.familiares">
                    <div v-for="(fam, j) in tr.familiares" :key="j">
                        <p class="mb-0"><small>NOMBRE DE <span class="text-uppercase">{{fam.parentesco}}</span></small></p>
                        <p><strong>{{fam.fullName}}</strong></p>
                    </div>
                </div>
            </vs-td>
            <vs-td >
                <vs-button
                    success
                    flat
                    @click="activeVincularFamiliares =! activeVincularFamiliares, info = tr"
                >
                    Vincular familiares desde el SIM
                </vs-button>
            </vs-td>
          </vs-tr>
        </template>
        <template #notFound>
            No hay información
        </template>
      </vs-table>
      <vincular-familiares v-model="activeVincularFamiliares" :info="info" @refreshTable="refreshInfo"></vincular-familiares>
    </div>
</template>
<script>
import VincularFamiliares from './modal/vincular.vue'
export default {
    props: [
        'users',
        'institucionSelect',
        'instituciones',
        'ciclo',
    ],
    data:() => ({
        activeVincularFamiliares: false,
        activeVincularPadres: false,
        info: []
    }),
    methods:{
        refreshInfo(){
            this.$emit('refreshTable')
        },
        
    },
    components:{
        VincularFamiliares,
    }
}
</script>

        